import { Component, OnInit, HostListener, ViewChild, AfterViewInit } from "@angular/core";
import { PackageDataService } from "../../data-services/package.service";
import { DialogService } from "primeng/dynamicdialog";
import { RequisitionDataService } from "../../data-services/requisition.service";
import { DatePipe } from "@angular/common";
import { MessageService } from "primeng/api";
import { ComponentCanDeactivate } from "../../helpers/pending-changes.guard";
import { Observable } from "rxjs";
import { ConfirmationService } from "primeng/api";
import { LookupService } from "../../data-services/lookup.service";
import { RequisitionIntakeDataService } from "../../data-services/requisitionIntake.service";
import { Howl } from 'howler';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { NgxBarcode6 } from 'ngx-barcode6';

@Component({
  selector: "app-package-open",
  templateUrl: "./package.open.html",
  styleUrls: ["./package.open.css"],
  providers: [DialogService, DatePipe, MessageService, ConfirmationService],
  imports: [ButtonModule, Dialog, FormsModule, ConfirmDialog, Toast, CommonModule, TableModule, RadioButtonModule, NgxBarcode6]
})
export class PackageOpenComponent implements OnInit, AfterViewInit, ComponentCanDeactivate {

  @ViewChild("samplefast", { static: false })
  sampleComponent;
  @ViewChild("ordersearch")
  searchBox;
  @ViewChild("rebarCode")
  newSerialBox;

  package: any = {};
  order: any = {};
  imagePath: any;
  cols: any[];
  executionMode = 1;
  hasAlert = false;
  isOpened = false;
  isCompleted = false;
  hasBeenSentToOvation = false;
  showSpinner = false;
  loading = false;
  orderSearch: string;
  medtekOrder: any;
  specimenTypes: any[];
  originalMessageLevel: any;
  rejectDisabled = false;
  deleteDisabled = false;
  completePackageDisabled = false;
  pendingOrders: any[] = [];
  showNameConfirmDialog = false;
  showSpecimenSelectDialog = false;
  showPaperReqDialog = false;
  showDuplicateDialog = false;
  newSerial: any;
  newSerialVerified: boolean;
  newLabelApplied = false;
  printLabelOption = false;

  constructor(private packageDataService: PackageDataService,
    private requisitionService: RequisitionDataService,
    private requisitionIntakeService: RequisitionIntakeDataService,
    private lookupService: LookupService,
    public dialogService: DialogService,
    public datepipe: DatePipe,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) {
  }

  @ViewChild("sampleForm")
  sampleForm: any;

  ngOnInit() {
    this.lookupService.getSpecimenTypes().subscribe((data: any) => {
      this.specimenTypes = data;
    });
    this.cols = [
      { field: "Accession", header: "Sample Serial Number" },
    ];
  }

  ngAfterViewInit() {
    this.searchBox.nativeElement.focus();
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    this.leavingSample();
    if (this.package && this.package.IsOpened && !this.package.IsCompleted) {
      return false;
    } else {
      return true;
    }
  }

  //Barcode scanning/entry handling
  barcode = "";
  barcodeReading = false;

  @HostListener("document:keypress", ["$event"])
  handleKeystroke({ keyCode, key }) {
    if (keyCode === 13) {

      if (this.barcodeReading) {
        this.handleBarCode(this.barcode);
      }
      if (this.showDuplicateDialog) {
        this.verifyNewAccession();
      } else {
        this.handleBarCode(this.orderSearch);
      }
      this.barcode = "";
    } else {
      //while not an 'enter', store every key    
      this.barcode += key;
    }

    //after a timeout of 200ms on the first read, clear everything
    if (!this.barcodeReading) {
      this.barcodeReading = true;
      setTimeout(() => {
          this.barcode = "";
          this.barcodeReading = false;
        },
        200);
    }
  }

  handleBarCode(code: string) {
    code = code.replace(/[^ -~]+/g, "");

    if (code.length > 5) {

      if (!this.package.Id) {
        let id = code;
        if (code.length > 12) {
          id = code.slice(code.length - 12);
        }
        this.getPackage(id);

      } else {
        this.lookupMedtekOrder(code);
      }
    }
    this.orderSearch = "";
  }

  private getPackage(trackingId: string) {
    if (this.package.Id != null &&
      this.package.IsOpened &&
      !this.package.IsCompleted) {
      this.messageService.add({
        severity: "warn",
        summary: "Package",
        detail: "Automatically closing current package before opening new one."
      });
      this.completePackage();
    }

    this.showSpinner = true;
    this.loading = true;
    this.packageDataService.getPackageForIntake(trackingId).subscribe((data: any) => {
        this.order = {};
        if (data == null) {
          this.confirmPackageNotReceived(trackingId);
          this.package = {};
        } else {
          this.package = data;
          if (!this.package.Requisitions) {
            this.package.Requisitions = [];
          }
          if (this.package.Client && this.package.Client.ProcessingType == 3) {
            this.showPaperReqDialog = true;
          } else if (this.package.IsCompleted) {
            this.confirmReOpenPackage(trackingId);
          }
        }
        this.showSpinner = false;
        this.loading = false;
      },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Package",
          detail: `Package retrieval has failed: ${err.status}`
        });
        this.package = {};
        this.showSpinner = false;
      });
  }

  leavingSample() {

    if (this.order == null || this.order.Accession == null) {
      return;
    }

    if (!this.order.Id || this.sampleForm.dirty) {
      this.package.Requisitions = this.package.Requisitions.filter(item => item.Accession != this.order.Accession);
      this.package.Requisitions.unshift(this.order);
      this.pendingOrders.unshift(this.order);
      this.requisitionIntakeService.Save(this.order).subscribe((data: any) => {
          this.sampleForm.reset();
          this.pendingOrders = this.pendingOrders.filter(x => x.Accession != data.Accession);
          var rows = this.package.Requisitions.filter(x => x.Accession == data.Accession);
          if (rows.length > 0) {
            rows[0] = data;
          } else {
            this.package.Requisitions.unshift(data);
          }
          this.showSpinner = false;
        },
        (err) => {
          this.messageService.add({
            severity: "error",
            summary: "Saving Sample",
            detail: "Error saving sample. Please try again"
          });
          this.showSpinner = false;
        });
    }

    this.newSerial = null;
    this.showDuplicateDialog = false;
    this.newSerialVerified = null;

    this.order = {};
  }

  specimensAvailableList() { return this.specimenTypes?.filter(item => item.Code !== this.order.SpecimenTypeCode) };


  getSpecimenTypeNameByCode(code: string) {
    const specimenType = this.specimenTypes?.find(x => x.Code === code);
    return specimenType?.Name;
  }

  changeSpecimenType(event: any) {
    this.order.PatientSampleObserved = this.order.SpecimenTypeCode;
    if (!this.order.SpecimenTypeMatch) {
      this.showSpecimenSelectDialog = true;
    }
  }


  closeSpecimenConfirmDialog(isCancel: boolean) {
    this.showSpecimenSelectDialog = false;
    if (isCancel) {
      this.order.PatientSampleObserved = this.order.SpecimenTypeCode;
      this.order.SpecimenTypeMatch = true;
    }
  }

  completePackage() {
    this.completePackageDisabled = true;
    this.showSpinner = true;
    this.leavingSample();
    this.package.IsOpened = true;
    setTimeout(() => {
        this.packageDataService.completePackage(this.package.Id).subscribe(() => {
            this.messageService.add({
              severity: "success",
              summary: "Success!",
              detail: "This package has been marked as complete."
            });
            this.completePackageDisabled = false;
            this.package.IsCompleted = true;
            this.showSpinner = false;
          },
          (err) => {
            this.messageService.add({
              severity: "error",
              summary: "Package",
              detail: `Unable to mark the package as complete!: ${err.status}`
            });
            this.showSpinner = false;
          });

        this.order = {};
        this.package = {};
      },
      1000);
    this.searchBox.nativeElement.focus();
  }

  openPackage() {
    this.packageDataService.openPackage(this.package.Id).subscribe(() => {
        this.messageService.add({ severity: "success", summary: "Package", detail: "The package has been opened" });
        this.package.IsOpened = true;
      },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Package",
          detail: `Unable to mark the package as opened!: ${err.status}`
        });
      });
  }

  handleSearchButton() {
    this.handleBarCode(this.orderSearch);
  }

  onAlertChanged(event) {
    this.hasAlert = event;
  }

  noElectronicOrder = false;

  getExistingRequisition(accession) {
    this.leavingSample();
    this.requisitionIntakeService.getExisting(accession).subscribe((data: any) => {
      this.order = data;
      this.hasBeenSentToOvation = data.DateSentToOvation != null;
    });
  }

  lookupMedtekOrder(accession) {
    this.leavingSample();
    if (this.package.Id == null) {
      this.messageService.add({
        severity: "error",
        summary: "Sample Scan",
        detail: "Please scan or enter the package before adding any samples."
      });
      return;
    }

    if (this.alreadyHasSerialNumber(accession)) {
      if (!this.confirmDuplicate(accession)) {
        //user canceled
        return;
      } else {
        this.getMTOrder(accession);
      }
    }

    if (this.isCompleted) {
      this.confirmationService.confirm({
        message:
          "This package has been completed and cannot have samples add to it. If samples need to be added to it, please request that a supervisor reopen this package.",
        acceptLabel: "OK",
        rejectVisible: false,
        accept: () => {
          return;
        }
      });
      return;
    }

    if (this.package == null || this.package.Id == null) {
      this.messageService.add({
        severity: "error",
        summary: "Specimen Scan",
        detail: "Please scan or enter the package before adding any specimens."
      });
      return;
    } else {
      this.getMTOrder(accession);
    }
  }

  getMTOrder(accession, originalSerialNumber = null) {
    this.showSpinner = true;
    if (!this.package.IsOpened) {
      this.openPackage();
    }
    this.order = {};
    this.requisitionIntakeService.getForIntake(accession, this.package.Id).subscribe((data: any) => {
        this.order = data;
        this.order.SpecimenTypeMatch = true;
        this.order.NameMatch = null;
        this.order.BirthDateMatch = null;
        this.order.PatientSampleObserved = null;
        this.originalMessageLevel = this.order.MessageLevel;
        if (this.order.IsDuplicate) {
          this.order.Exception = { IssueDescription: "Duplicate Accession " };
          this.showDupDialog(accession);
        }
        //if (originalSerialNumber) {
        //  this.order.SpecimenSerialNumber = originalSerialNumber;
        //}
        if (this.order.OrderProcessingType == 2 && !this.showDuplicateDialog) {
          this.showNameConfirmDialog = true;
        }
        this.showSpinner = false;
      },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Order",
          detail: "Error retrieving sample. Please try again"
        });
        this.showSpinner = false;
      });
  }

  rejectClicked() {
    this.rejectDisabled = true;
    this.order.IsLIT = !this.order.IsLIT;
    let rejectionType = "0";
    if (this.order.IsLIT) {
      this.order.IsRejected = true;
      rejectionType = "1";
      this.order.IsLIT = true;
      if (!this.order.RequisitionRejections) {
        this.order.RequisitionRejections = [];
      }
      this.order.RequisitionRejections.unshift({
        Accession: this.order.Accession,
        RejectionType: 1,
        RejectionTypeName: "Leaked in Transit (LIT)",
        Selected: true,
        Unrejected: false
      });
    } else {
      rejectionType = "1";
      this.order.IsLIT = false;
      this.order.MessageLevel = this.originalMessageLevel;
      this.order.RequisitionRejections = this.order.RequisitionRejections.filter(x => x.RejectionType != 1);
      if (this.order.RequisitionRejections.length == 0) {
        this.order.IsRejected = false;
      }
    }
    if (this.order.Id > 0) {
      //we are looking at one that has already been saved - so call the update right now
      const types: string[] = new Array();
      types.push(rejectionType);
      this.requisitionService.rejectRequisition(this.order.Accession, types, "").subscribe((data: any) => {
        this.rejectDisabled = false;
      });
    } else {
      this.rejectDisabled = false;
    }
  }

  deleteClicked() {
    this.deleteDisabled = true;
    if (this.order.Id > 0) {
      this.requisitionService.deleteRequisition(this.order.Id).subscribe((data: any) => {
        this.package.Requisitions = this.package.Requisitions.filter(item => item.Accession != this.order.Accession);
        this.order = {};
        this.deleteDisabled = false;
      });
    } else {
      this.order = {};
      this.deleteDisabled = false;
    }
  }

  confirmDuplicate(accession: string): boolean {
    const msg = `This number has already been added to this package.<br/><br/>If you accidentally rescanned the
      same sample then please hit the Cancel button and proceed.<br/>If this is really a different
      sample with a duplicate number then please hit the Continue button.`;

    this.confirmationService.confirm({
      message: msg,
      icon: "pi pi-exclamation-triangle",
      header: `Duplicate Serial Number - ${accession}`,
      acceptLabel: "Continue",
      rejectLabel: "Cancel",
      accept: () => {
        this.showDupDialog(accession);
        return true;
      },
      reject: () => {
        return false;
      }
    });
    return false;
  }

  showDupDialog(accession) {
    this.order.Status = "Received";

    this.order.HasExceptions = true;
    this.order.SpecimenSerialNumber = accession;
    this.order.PackageId = this.package.Id;
    this.order.LabId = this.package.LabId;
    this.showDuplicateDialog = true;
    setTimeout(() => {
        this.newSerialBox.nativeElement.focus();
      },
      200);
  }

  confirmReOpenPackage(trackingId: string): boolean {
    const msg = "This package has already been processed and closed.<br/><br/>" +
      "If there are unprocessed samples for this package, hit the Reopen button, otherwise press the Cancel button";

    this.confirmationService.confirm({
      message: msg,
      icon: "pi pi-info-circle",
      header: `Package Already Closed - ${trackingId}`,
      acceptLabel: "Reopen",
      rejectLabel: "Cancel",
      accept: () => {
        this.package.IsCompleted = false;
        return true;
      },
      reject: () => {
        this.package = {};
        return false;
      }
    });
    return false;
  }

  confirmPaperClient(client: any): boolean {
    const msg = "This client associated with this package is configured for Paper Requisitions<br/><br/>" +
      "This package cannot be processed in LabTek21, it must be processed in QuickBase.";

    this.confirmationService.confirm({
      message: msg,
      header: `Paper Requisition Client - ${client.Name}`,
      acceptLabel: "OK ",
      rejectLabel: "Cancel ",
      accept: () => {
        return true;
      },
      reject: () => {
        return false;
      }
    });
    return false;
  }

  confirmPackageNotReceived(trackingId: any): boolean {
    const msg = "This package has not been received.<br/><br/>Send it back to the Package Receiving team.";

    this.confirmationService.confirm({
      message: msg,
      header: `Package Not Received - ${trackingId}`,
      acceptLabel: "OK ",
      rejectLabel: "OK ",
      accept: () => {
        return true;
      },
      reject: () => {
        return false;
      }
    });
    return false;
  }

  sampleCompleted(success: boolean) {
    this.searchBox.nativeElement.focus();
  }

  alreadyHasSerialNumber(accession): boolean {
    const ret = this.package.Requisitions.find(
        r => r.Accession != null &&
        r.Accession.toLowerCase() == accession.toLowerCase()) !=
      null;
    return ret;
  }

  isNextDisabled(): boolean {
    const specimenTypeValid = (this.order.SpecimenTypeMatch === false && this.order.PatientSampleObserved !== null) || this.order.SpecimenTypeMatch === true;
    const x = !(this.order.NameMatch != null &&
      this.order.BirthDateMatch != null && specimenTypeValid
    );
    return x;
  }

  closeNameConfirmDialog() {
    const exceptionMessage = "";
    if (this.order.NameMatch === false && this.order.BirthDateMatch === false) {
      if ((this.order.PatientSampleObserved !== this.order.SpecimenTypeCode && this.order.SpecimenTypeMatch === false) &&
        this.order.SpecimenTypeMatch === false) {
        this.order.IsPatientSampleMismatch = true;
        this.order.Exceptions.push({ IssueDescription: `Specimen Mismatch - Observed: ${this.order.PatientSampleObserved}`});
      }
      const orderSource = this.order.OrderSource;
      const dateReceived = this.order.DateReceived;
      this.order.Accession = null;
      this.order.Id = 0;
      this.order.SpecimenSerialNumber = null;
      this.order.DateReceived = dateReceived != null ? dateReceived : `${new Date()}`;
      this.order.OrderSource = orderSource;
      this.order.Exceptions.push({ IssueDescription: `Label Mismatch` });
      this.order.IsPatientMismatch = true;
      this.order.HasExceptions = true;
      this.showDupDialog(this.order.Accession);
    } else if ((this.order.PatientSampleObserved !== this.order.SpecimenTypeCode && this.order.SpecimenTypeMatch === false) &&
      this.order.SpecimenTypeMatch === false) {
      this.order.Exceptions.push({ IssueDescription: `Specimen Mismatch - Observed: ${this.order.PatientSampleObserved}` });
      this.order.IsPatientSampleMismatch = true;
      this.order.HasExceptions = true;
    }

    this.showNameConfirmDialog = false;
  }

  cancelNameConfirmDialog() {
    this.showNameConfirmDialog = false;
    this.order = {};
  }

  closePaperReqDialog() {
    this.showPaperReqDialog = false;
    this.package = {};
  }


  cancelDuplicateDialog() {
    this.showDuplicateDialog = false;
    this.showNameConfirmDialog = false;
    this.order = {};
  }

  closeDuplicateDialog() {
    //set the properties on a new blank order to represent the duplicate
    this.order.Accession = this.newSerial;
    this.order.StatusLevel = 2;
    this.newSerial = null;
    this.newSerialVerified = null;
    this.newLabelApplied = true;

    this.showDuplicateDialog = false;
    this.searchBox.nativeElement.focus();

  }

  verifyNewAccession() {
    this.requisitionIntakeService.canAccessionBeUsed(this.newSerial).subscribe((data: any) => {
        if (data) {
          this.newSerialVerified = true;
          this.closeDuplicateDialog();
        } else {
          this.newSerial = "";
          this.newSerialVerified = false;
        }
      },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Verify New Serial",
          detail: "Error verifying serial number. Please try again"
        });
        this.newSerialVerified = false;
      });
  }

  goodSound: Howl = new Howl({
    src: ["../assets/sounds/good.wav"]
  });
  badSound: Howl = new Howl({
    src: ["../assets/sounds/bad.mp3"]
  });

  playGoodSound() {
    this.goodSound.play();
  }

  playBadSound() {
    this.badSound.play();
  }
}
